import React from 'react';
import { Icon } from './components/Icon/Icon';
import { DefaultLogo } from 'components/DefaultLogo/DefaultLogo';

import './MaintenancePage.scss';

function MaintenancePage() {
  return (
    <div className="MaintenancePage">
      <div className="content">
        <Icon />
        <h1>Maintenance mode</h1>
        <p>
          Sorry, our site is currently under maintenance.
          <br />
          We will be back in approximately 30 minutes.
        </p>
        <div>
          <a href="https://www.flywire.com">Flywire.com</a>
          <a href="https://help.flywire.com">FAQ</a>
        </div>
      </div>
      <div className="footer">
        <DefaultLogo />
      </div>
    </div>
  );
}

export { MaintenancePage };
